<script lang="ts">
    import {createEventDispatcher, getContext, onMount} from "svelte";
    import defaultCustomize from "../helper/defaultCustomize";
    import {fly} from 'svelte/transition';
    import iconStore from "../store/iconStore";
    import Icon from "../parts/Icon.svelte";
    import {createEmptyMessage, Message} from "../@type";

    const dispatcher = createEventDispatcher();

    const custom = getContext("custom") || defaultCustomize;
    export let editingMessage: Message = createEmptyMessage();
    export let selected: boolean = false;
    let beforeMessage: string;

    onMount(() => {
        beforeMessage = JSON.stringify(editingMessage);
    });

    function setMetadata(bodyClass: string) {
        editingMessage.metadata = Object.assign({}, {bodyClass});
        editingMessage = editingMessage;
    }

    function selectIcon(sIcon) {
        editingMessage.icon = sIcon;
        editingMessage = editingMessage;
    }

    function enter() {
        dispatcher("edit-enter", editingMessage);
    }

    function cancel() {
        dispatcher("edit-cancel", JSON.parse(beforeMessage));
    }

</script>
<div class="message-action-separate message-edit" class:selected>
    <svelte:component this={custom.messageSelector(editingMessage)} message={editingMessage} on:icon-click on:reply>
        <div slot="selectDesign" in:fly="{{ x: -100, duration: 500 }}">
            <span style="border:3px black double;" on:click={() => setMetadata("")}></span>
            <span style="border:3px black double;background-color:lightgray;"
                  on:click={() => setMetadata("gray")}></span>
            <span class="letter" on:click={() => setMetadata("letter")}><p class="text">○</p></span>
        </div>
        <svelte:fragment slot="body">
            <textarea class="text" bind:value={editingMessage.body}></textarea>
            <div class="message-edit-action">
                <i class="icon-checkmark" on:click={enter}/>
                <i class="icon-delete" on:click={cancel}/>
            </div>
        </svelte:fragment>
    </svelte:component>

    <div class="message-action-separate message-icon" style="border-color:green;padding-top:0.5em"
         in:fly="{{ y: 100, duration: 900 }}">
        <i class="game-icon game-icon-cancel"
           style="width:50px;text-align:center;font-size:xx-large;color:black;line-height: 52px;height:50px;border:1px ridge lightgray"></i>
        {#each $iconStore as icon (icon.id)}
            <Icon icon={icon} name={icon.name} on:click={selectIcon(icon)}/>
        {/each}
        <i class="game-icon game-icon-photo-camera"
           style="width:50px;text-align:center;font-size:xx-large;color:black;line-height: 52px;height:50px;border:1px ridge lightgray"></i>
    </div>
</div>

<style>
    textarea {
        width: 100%;
        height: 4em;
    }

    [slot="selectDesign"] > .letter > .text {
        padding: 0 !important;
        margin: 0;
        height: 100%;
        width: 100%;
        text-align: center;
        line-height: 2em;
        box-sizing: border-box;
    }

    .message-edit-action {
        display: flex;
        flex-direction: row;
        padding: 0 1rem;
        align-items: center;
        flex-wrap: wrap;
        max-height: 10em;
    }

    .message-edit-action > i {
        font-size: 2em;
        margin: 0 0.5rem;
    }

    @media screen and (max-width: 500px) {
        .message-edit-action {
            padding:0;
        }
        textarea {
            width: 100%;
            height: 10em;
        }
    }
</style>